function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import * as S from './Link.styles';
const LinkVariants = {
  primary: S.LinkFilled,
  outline: S.LinkOutline,
  text: S.LinkText
};
const Link = /*#__PURE__*/React.forwardRef(({
  ariaLabel,
  children,
  href,
  variant = 'text',
  size = 'medium',
  isInline = true,
  isBold = false,
  hasPadding = false,
  disabled,
  width,
  ...props
}, ref) => {
  const LinkComponent = LinkVariants[variant];
  const inline = width === 'full' ? false : isInline;
  return /*#__PURE__*/React.createElement(S.LinkWrapper, {
    $isInline: inline,
    $variant: variant,
    $isBold: isBold,
    $hasPadding: hasPadding,
    $width: width
  }, /*#__PURE__*/React.createElement(LinkComponent, _extends({
    ref: ref,
    href: href,
    rel: props.target === '_blank' ? 'noopener noreferrer' : '',
    "aria-label": ariaLabel,
    $size: size,
    $hasPadding: hasPadding,
    $disabled: disabled
  }, props), children));
});
export { Link };